import React from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import { defaultColours } from '../../utils/styling';

function Colours( { theme, children } ) {

  return (
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  )
}

Colours.propTypes = {
  theme: PropTypes.object,
};

Colours.defaultProps = {
  theme: defaultColours
};

export default Colours;
